// https://gist.github.com/JeffJacobson/3841577

/**
 * Splits a Pascal-Case word into individual words separated by spaces.
 * @param {Object} word
 * @returns {String}
 */
function splitPascalCase(word: string): string {
  const wordRe = /($[a-z])|[A-Z][^A-Z]+/g;
  const match = word.match(wordRe);
  return match ? match.join(' ') : word;
}

/**
 * Splits a camelCase or PascalCase word into individual words separated by spaces.
 * @param {Object} word
 * @returns {String}
 */
function splitCamelCase(word: string) {
  const output: string[] = [];
  let i: number;
  let l: number;
  const capRe = /[A-Z]/;
  if (typeof word !== 'string') {
    throw new Error('The "word" parameter must be a string.');
  }
  for (i = 0, l = word.length; i < l; i += 1) {
    if (i === 0) {
      output.push(word[i].toUpperCase());
    } else {
      if (i > 0 && capRe.test(word[i])) {
        output.push(' ');
      }
      output.push(word[i]);
    }
  }
  return output.join('');
}

export { splitPascalCase, splitCamelCase };
